module.exports = __webpack_public_path__ + "media/components/dashboard/icons/income-6481a674cb61886322697acf23cf34af.svg";